import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { POTTERY_IMAGE, POTTERY_SITE_URL } from "../lib/api";
import { useContent } from "../lib/content";

export const PotteryPromo = () => {
  const { t } = useContent();

  return (
    <section id="pottery" className="bg-[#eae4da]">
      <div className="relative h-56 sm:h-72 overflow-hidden">
        <img
          src={POTTERY_IMAGE}
          alt="Hands shaping clay on a pottery wheel"
          loading="lazy"
          className="w-full h-full object-cover"
        />
      </div>
      <motion.div
        data-testid="pottery-promo-box"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="grid md:grid-cols-3"
      >
        <div className="bg-[#1d1d1b] text-[#eae4da] p-10 sm:p-12">
          <p className="font-display font-extrabold text-5xl sm:text-6xl tracking-[-0.03em]">02</p>
          <p className="font-editorial text-xl mt-4 text-[#eac119]">{t("pottery_kicker")}</p>
          <p className="text-[10px] font-bold tracking-[0.28em] uppercase text-[#eae4da]/50 mt-2">
            MAS Pottery Studio
          </p>
        </div>
        <div className="bg-[#808bc5] text-[#1d1d1b] p-10 sm:p-12 flex flex-col justify-center">
          <div className="flex items-center gap-5">
            <img
              src={t("pottery_image") || POTTERY_IMAGE}
              alt="Someone shaping pottery on the wheel"
              loading="lazy"
              className="w-20 h-20 sm:w-24 sm:h-24 rounded-2xl object-cover border-4 border-white/50 shadow-lg shrink-0 -rotate-3"
            />
            <h2 className="font-display font-extrabold tracking-[-0.02em] text-2xl sm:text-3xl leading-[1.15]">
              {t("pottery_heading")}
            </h2>
          </div>
          <p className="mt-4 text-sm leading-relaxed font-semibold text-[#1d1d1b]/80 max-w-sm">
            {t("pottery_text")}
          </p>
        </div>
        <div className="bg-[#ed773c] p-10 sm:p-12 flex flex-col items-start justify-center gap-5">
          <a
            data-testid="pottery-promo-button"
            href={POTTERY_SITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3 rounded-full border-2 border-[#1d1d1b] text-[#1d1d1b] font-display font-extrabold text-lg px-7 py-3.5 hover:bg-[#1d1d1b] hover:text-[#ed773c] transition-all duration-300"
          >
            {t("pottery_button")}
            <ArrowUpRight size={19} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
          <p className="text-xs font-mono-mas tracking-[0.14em] text-[#1d1d1b]/70">
            maspottery.website
          </p>
        </div>
      </motion.div>
    </section>
  );
};
